import { render, staticRenderFns } from "./VueInputTag.vue?vue&type=template&id=17bcd050&scoped=true"
import script from "./VueInputTag.vue?vue&type=script&lang=js"
export * from "./VueInputTag.vue?vue&type=script&lang=js"
import style0 from "./VueInputTag.vue?vue&type=style&index=0&id=17bcd050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bcd050",
  null
  
)

export default component.exports